import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const BackgroundContainer = styled.div`
  height: 100vh;
  background-color: white;
`
export const FormContainer = styled.form`
    min-width: 970px;
    max-width: 1150px;
    padding: 30px 30px;
    margin: 30px 0 30px;
    border-radius: 10px;
    background: var(--white);
    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.25);

    @media (max-width: 1000px) {
        min-width: 100%;
        width: 100%;
        padding: 20px;
    }
`

export const Header = styled.h1`
    color: var(--dark-gray);
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    margin: 40px 0 5px 0;
    
    @media (max-width: 1000px) {
        font-size: 1.3rem;
        margin: 30px 0 5px 0;
    }
`;

export const SubTitle = styled.p`
    color: var(--gray);
    font-size: 1rem;
    text-align: center;
    margin: 0;

    @media (max-width: 1000px) {
        font-size: 0.9rem;
    }
`;

export const InputContainer = styled.div`
    display: grid;
    grid-template-columns: 140px 1fr 200px;
    gap: 20px;

    @media (max-width: 1000px) {
        grid-template-columns: 1fr;
    }
`;

export const SliderContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    padding: 20px;

    @media (max-width: 1000px) {
        padding: 20px;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;

    @media (max-width: 1000px) {
        width: 100%;
        button {
            width: 100% !important;
        }
    }
`

export const AssociatesAndMapContainer = styled.div`
    display: flex;
    gap: 2rem;
    flex-direction: row;
    width: 100%;
    padding: 2rem 0;
    height: 75vh;

    @media (max-width: 1000px) {
      flex-direction: column-reverse;
      height: auto;
      gap: 0.5rem;
    }
`


export const AssociatesContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;

    @media (max-width: 1000px) {
      height: auto;
    }
`
export const AssociatesNotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 2rem 0;
  font-size: 1.3rem;
  color: var(--gray);
`

export const MapContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;

    @media (max-width: 1000px) {
        height: 400px;
    }
`

export const ErrorMessage = styled.p`
  color: #d32f2f;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  font-weight: 500;
`

export const MapSkeletonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
`
